import { render, staticRenderFns } from "./FormulatePassword.vue?vue&type=template&id=2b1b07c1&"
import script from "./FormulatePassword.js?vue&type=script&lang=js&"
export * from "./FormulatePassword.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b1b07c1')) {
      api.createRecord('2b1b07c1', component.options)
    } else {
      api.reload('2b1b07c1', component.options)
    }
    module.hot.accept("./FormulatePassword.vue?vue&type=template&id=2b1b07c1&", function () {
      api.rerender('2b1b07c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Formulate/FormulatePassword/FormulatePassword.vue"
export default component.exports